<template>
  <div id="the-artist">
    <b-container class="the-artist-container">
      <div class="header-cont">
        <Header title="The Artist" />
      </div>
    </b-container>

    <PlayerSpotlight
      playerName="SAM KIRK"
      :playerImages="[
        require('@/assets/images/galleries/sam/theartist/Sam-Slider-01.jpg'),
        require('@/assets/images/galleries/sam/theartist/Sam-Slider-02.jpg'),
        require('@/assets/images/galleries/sam/theartist/Sam-Slider-03.jpg'),
        require('@/assets/images/galleries/sam/theartist/Sam-Slider-04.jpg'),
      ]"
      :orientation="'vertical'"
    >
      <div slot="primaryParagraph">
        <p>
          Sam Kirk is a Chicago-based multidisciplinary artist and biracial, queer woman whose artwork
          focuses on a variety of intersections which encompass a call to celebrate differences and enact change.
          Vivid and powerful images of women, members of the LGBTQ community, and those who have historically
          been underrepresented are celebrated throught her artwork.
        </p>
        <p>
          Kirk's vibrant color palette, intricate line work and layered backgrounds highlight cultural communities
          via multitioned figures recalled from memories of her travels throughout the world. Kirk's public
          murals often address social issues, as she intentionally uses the public space to spark dialogue
          around topics of equality and visibility for women, communities of color and the LGBTQ community.
          <br />
          <br />
          To learn more about Sam Kirk, visit:
          <a
            href="http://iamsamkirk.com/"
            target="_blank"
            style="color: #ce0e2d"
            >iamsamkirk.com.</a
          >
        </p>
      </div>
    </PlayerSpotlight>
  </div>
</template>

<script>
import ImageGallery from "@/components/global/ImageGallery";
import Header from "@/components/global/Header";
import PlayerSpotlight from "@/components/global/PlayerSpotlight";

export default {
  name: "TheArtist",
  components: {
    ImageGallery,
    Header,
    PlayerSpotlight,
  },
};
</script>

<style lang="scss" scoped>
#the-artist {
  .the-artist-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    @media (max-width: $lg) {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  .header-cont {
    margin-top: 90px;
    margin-bottom: 40px;
  }
  .italic {
    font-family: AvenirNext-Medium-Italic;
    font-size: 16px;
    color: #3e3e3e;
    text-align: center;
    line-height: 25px;
    width: 587px;
    max-width: 100%;
    &:after {
      content: url("~@/assets/images/icons/Close-Quote-Small.svg");
      width: 16px;
      height: 10px;
      padding-left: 8px;
      transform: scale(0.5);
    }
    &:before {
      content: url("~@/assets/images/icons/Open-Quote-Small.svg");
      width: 16px;
      height: 10px;
      padding-right: 8px;
    }
  }
}
</style>
